import { observer } from "mobx-react-lite";
import { Flex, Divider, Typography } from "antd";
import { TransitWalletBlock } from "./TransitWalletBlock";
import { AmountBlock } from "./AmountBlock";
import { getBankColumns } from "./getBankColumns";
import { ItemInfo, ItemInfoBlock } from "components";
import { useStores } from "stores";
import { WhiteBoxBlock } from "ui";
import { BID_REQUEST_STATUS_ENUM, BidRequestStatus } from "interfaces";
import { getColumns, getTitle } from "./getColumns";
import styles from "./bidInfo.module.css";
import { RubBalanceBlock } from "./RubBalanceBlock/RubBalanceBlock";
import { CurrencyCodeEditBtn } from "../CurrencyCodeEditBtn";
import { isStatusIncluded } from "utils";
// import { DIRECT_PAYMENT_CUSTOMER_LP } from "utils/envConstants";
// import { isStatusIncluded } from "utils";

export const BidInfoBlocks = observer(() => {
  const { user, bidCard, bidHistory } = useStores();

  const { isCustomer, isSeniorOperator } = user.roles;

  const canChangeCurrencyOperationCode =
    (isCustomer &&
      isStatusIncluded(bidCard.bid.status, [
        BID_REQUEST_STATUS_ENUM.DRAFT,
        BID_REQUEST_STATUS_ENUM.DRAFT_APPROVED,
        BID_REQUEST_STATUS_ENUM.AGENT_PROPOSAL,
        BID_REQUEST_STATUS_ENUM.NEW,
      ])) ||
    isSeniorOperator;

  //Не удалять пока аналитика не поймет что rubBalance нужно показывать всегда
  // const { isOperator, isCustomer, isJuniorLP, isSeniorLP } = user.roles;
  // const { requestProcessing, contract, rubBalance, status } = bidCard.bid;

  // const isLpProvider = isJuniorLP || isSeniorLP;

  // const isExp = contract.direction === "EXP";
  // const isImp = contract.direction === "IMP";

  // const showRubBalance =
  //   !!rubBalance &&
  //   !DIRECT_PAYMENT_CUSTOMER_LP &&
  //   !isStatusIncluded(status, [
  //     BID_REQUEST_STATUS_ENUM.DRAFT,
  //     BID_REQUEST_STATUS_ENUM.DRAFT_APPROVED,
  //     BID_REQUEST_STATUS_ENUM.AGENT_PROPOSAL,
  //     BID_REQUEST_STATUS_ENUM.AGENT_PROPOSAL_ACCEPTED,
  //     BID_REQUEST_STATUS_ENUM.NEW,
  //     BID_REQUEST_STATUS_ENUM.QUOTE_PROPOSED,
  //   ]);

  // const showRubBalanceExp =
  //   isOperator ||
  //   (isCustomer && isExp && !requestProcessing.fiatReceived) ||
  //   (isLpProvider && isExp && requestProcessing.fiatReceived);
  // const showRubBalanceImp =
  //   isOperator ||
  //   (isCustomer && isImp && requestProcessing.fiatReceived) ||
  //   (isLpProvider && isImp && !requestProcessing.fiatReceived);

  const bancColumns = getBankColumns(bidCard.bid, user);

  return (
    <WhiteBoxBlock className="full-width">
      <Flex justify="space-between" align="flex-start" className="full-width" gap="large">
        <Flex vertical className={styles.bidInfoBlock} id={getBlockId(bidCard.bid.status)}>
          <AmountBlock bid={bidCard.bid} />
          <ItemInfoBlock
            items={getColumns(bidCard.bid, user, bidHistory.processingHistoryTooltip)}
            oneColumn
            vertical={false}
          />

          {bancColumns.length > 0 && <Divider className="margin-top-none margin-bottom-sm" />}
          <ItemInfoBlock items={bancColumns} oneColumn vertical={false} />
        </Flex>
        <Flex className={styles.bidInfoBlock}>
          <TransitWalletBlock bid={bidCard.bid} user={user} />
        </Flex>
      </Flex>
    </WhiteBoxBlock>
  );
});

const getBlockId = (bidStatus: BidRequestStatus) => {
  switch (bidStatus) {
    case BID_REQUEST_STATUS_ENUM.AGENT_PROPOSAL:
      return "bid-info-block";
    case BID_REQUEST_STATUS_ENUM.NEW:
      return "bid-new-info-block";
    case BID_REQUEST_STATUS_ENUM.QUOTE_PROPOSED:
      return "bid-quote-proposed-info-block";
    default:
      return undefined;
  }
};
